"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var DomUtils_1 = require("epc-web-utils/dist/DomUtils");
var LoaderSize_1 = __importDefault(require("./LoaderSize"));
var BasicLoader_1 = __importDefault(require("./BasicLoader"));
var ModalLoader = function (props) {
    var title = props.title, visible = props.visible, otherProps = __rest(props, ["title", "visible"]);
    var backdropClasses = classnames_1.default('fds-loader-backdrop', { 'is-visible': visible });
    react_1.useEffect(function () {
        var elem = document.documentElement;
        if (visible) {
            DomUtils_1.addClass(elem, 'fds-loader-open');
        }
        else if (DomUtils_1.hasClass(elem, 'fds-loader-open')) {
            DomUtils_1.removeClass(elem, 'fds-loader-open');
        }
    }, [visible]);
    return (react_1.default.createElement("div", { className: backdropClasses, tabIndex: -1 },
        react_1.default.createElement(BasicLoader_1.default, __assign({}, otherProps, { size: LoaderSize_1.default.NORMAL, slide: true, visible: visible })),
        react_1.default.createElement("div", { className: "fds-loader-label" }, title)));
};
exports.default = ModalLoader;
